import { Col, Row } from "react-bootstrap";
import { compose, withState } from "recompose";

import ProjectReaffectForm from "./ProjectReaffectForm";
import Button from "../../elements/CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import _ from "lodash";
import { graphql } from "react-apollo";
import moment from "moment";


class ProjectReaffectSideModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        company: { id: props.companyId },
        newProjectId: null,
        newTiersClientId: null
      }
    };
  }

  reaffect = async values => {
    this.props.setWorkInProgress(true);

    console.log("31 - values=", values);

    const variables = {
      companyId: values.company.id,
      projectId: values.projectId,
      newProjectId: values.withoutProjectOrClient ? null : values.newProjectId,
      newTiersClientId: values.withoutProjectOrClient ? null : values.newTiersClientId
    };

    if (this.props.confirm) {
      this.props.confirm(variables);
    }
  };

  close = () => {
    console.log("close.state", this.state);
    this.props.close();
  };

  render = () => {
    const {
      title,
      sideModalVisible,
      companyId,
      sendNotification,
      intl,
      locale,
      formValues
    } = this.props;

    const values = {
      ...this.state.initialValues,
      companyId,
      projectId: formValues.projectId
    };

    console.log("88 - this.props=", this.props);

    const titleProject =
      <span>
        {title}
        {" : "}
        <span style={{ fontWeight: "bold" }} >
          {this.props.formValues.name}
        </span>
      </span>


    return (
      <SideModal
        title={titleProject}
        width="wide"
        visible={sideModalVisible}
        handleClose={this.close}
        children={
          <React.Fragment>
            <ProjectReaffectForm
              sendNotification={sendNotification}
              companyId={companyId}
              values={values}
              goBack={this.close}
              reaffect={this.reaffect}
              workInProgress={this.props.workInProgress}
              cancel={this.close}
              intl={intl}
              projectName={this.props.formValues.name}
              reaffectableToClient={this.props.reaffectableToClient}
              clientId={this.props.formValues.tiersClientId}
            />
          </React.Fragment>
        }
      />
    );
  };
}

const workInProgress = withState("workInProgress", "setWorkInProgress", () => {
  return false;
});

export default compose(
  workInProgress
)(ProjectReaffectSideModal);
